import { API_PATHS } from "../constants/api-paths";
import { COMMON_SSO_MOBILE } from "../constants/sso";
import { decryptLocalStorageMobileNo } from "@repo/shared-utils/crypto";
import { encryptedRequest } from "../core/api.client";

export interface GoldLoanDetails {
  eventCode?: string;
  saveForLaterFlag?: boolean;
}

export interface IApiResponseglRead {
  data: {
    goldLoanDetails?: GoldLoanDetails;
    description?: string;
    statusCode?: number;
  };
  statusCode: number;
  status: string;
  message: string;
}
export const getGlRead = async (appointmentId: string): Promise<IApiResponseglRead> => {
  const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
  const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
  try {
    const response = await encryptedRequest<IApiResponseglRead>({
      method: "POST",
      url: API_PATHS.glread,
      data: {
        appointmentId,
        mobileNo,
      },
    });
    return response;
  } catch (err) {
    console.error(err);
    throw err;
  }
};
